import './devbx.webform.form.row.css';

BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-form-row', {
        props: ['row'],
        data() {
            return {
                hoverId: false,
            };
        },
        methods: {
            elementClick(itemId) {
                this.$root.activeId = itemId;
            },

            mouseEnter(item) {
                this.hoverId = item.id;
            },

            mouseLeave(item) {
                if (this.hoverId == item.id) {
                    this.hoverId = false;
                }
            },

            beforeEnter: function (el) {
                el.style.opacity = 0;
                el.style.height = 0;
            },
            afterEnter: function (el) {
                el.style.height = '';
                el.style.opacity = '';
            },
            enter: function (el, done) {

                el.style.width = getComputedStyle(el).width;
                el.style.position = 'absolute';
                el.style.visibility = 'hidden';
                el.style.height = 'auto';

                let height = getComputedStyle(el).height;

                el.style.width = null;
                el.style.position = null;
                el.style.visibility = null;
                el.style.height = 0;


                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 1, height: height},
                        {complete: done}
                    )
                }, 100)
            },
            leave: function (el, done) {
                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 0, height: 0},
                        {complete: done}
                    )
                }, 100)
            }

        },
        computed: {
            items() {
                let result = [];

                this.row.items.forEach(item => {
                    let formElement = this.$root.getFormElementById(item.fieldId);

                    if (!formElement) {
                        if (this.$root.debug) {
                            console.error('form element not found ' + item.fieldId);
                            return;
                        }
                    }

                    let visible = true;

                    if (item.config.showRule) {
                        visible = !(this.$root.checkCondition(item, item.config, 'showRule') === false);
                    }

                    if (parseInt(item.config.systemId) <= 0) {
                        console.error('item.config.systemId', item.config.systemId);
                    }

                    if (!visible)
                        return;

                    let data = {
                        id: item.config.systemId,
                        template: formElement.data.layoutTemplate,
                        data: item,
                        cssClass: 'devbx-webform--col devbx-webform--col--' + item.size,
                        visible: visible,
                    };

                    result.push(data);
                });

                return result;
            },

            activeId() {
                return this.$root.activeId;
            },
        },

        template: `
      <transition-group name="devbx-webform-field" tag="div" class="devbx-webform-row devbx-webform-transition"
      v-bind:css="false"
      @before-enter="beforeEnter"
      @after-enter="afterEnter"
      @enter="enter"
      @leave="leave">
          <component
              v-for="(item,index) of items" 
              :key="item.id" 
              :class="item.cssClass"
              @click="elementClick(item.id)"
              @mouseenter="mouseEnter(item)"
              @mouseleave="mouseLeave(item)"                             
              :is="item.template"
              :item="item.data" 
              :config="item.data.config" 
              :row="row" 
              :active="activeId == item.id"
              />
      </transition-group>
    `
    });
});